import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Buildings } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

// Public social-proof strip for Signup / Login pages. Shows:
//   "Trusted by N warehouses · M companies across AU/NZ"
// + a horizontal list of customer names/logos.
// `variant="dark"` for the blue brand-panel (white text); `variant="light"`
// for white backgrounds (slate text).

export default function SocialProofStrip({ variant = 'dark', className = '' }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/public/social-proof`)
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, []);

  if (!data || (!data.warehouses_count && !data.companies_count)) return null;

  const dark = variant === 'dark';
  const labelClass = dark ? 'text-white/60' : 'text-muted-foreground';
  const strongClass = dark ? 'text-white' : 'text-foreground';
  const logoClass = dark
    ? 'border border-white/20 text-white/80 bg-card/5'
    : 'border border-border text-muted-foreground bg-card';

  return (
    <div className={`space-y-3 ${className}`} data-testid="social-proof-strip">
      <div className={`flex items-center gap-2 text-xs uppercase tracking-widest font-bold ${labelClass}`}>
        <Buildings size={14} weight="fill" />
        <span>
          Trusted by <span className={strongClass}>{data.warehouses_count}</span> warehouses ·{' '}
          <span className={strongClass}>{data.companies_count}</span> companies across AU / NZ
        </span>
      </div>
      {data.logos && data.logos.length > 0 && (
        <div className="flex flex-wrap gap-2" data-testid="social-proof-logos">
          {data.logos.map((l) => (
            <div
              key={l.id}
              data-testid={`social-proof-logo-${l.id}`}
              className={`inline-flex items-center gap-2 px-3 py-1.5 text-[11px] font-mono uppercase tracking-wider ${logoClass}`}
            >
              {l.logo_url && <img src={l.logo_url} alt={l.name} className="h-4 w-auto" />}
              <span>{l.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
